import type { IntlShape } from "@formatjs/intl";
import { Alert, Descriptions, Flex } from "antd";

type ReportSummaryStepProps = {
  filename: string;
  taskCount: number;
  tasksWithPictures: number;
  taskPictureCount: number;
  generalPictureCount: number;
  showGeneralPictures: boolean;
  usedSupplyCount: number;
  intl: IntlShape;
};

export function ReportSummaryStep({
  filename,
  taskCount,
  tasksWithPictures,
  taskPictureCount,
  generalPictureCount,
  showGeneralPictures,
  usedSupplyCount,
  intl,
}: ReportSummaryStepProps) {
  const items = [
    {
      key: "filename",
      label: intl.formatMessage({ id: "wo_report_summary_filename" }),
      children: filename,
    },
    {
      key: "tasks",
      label: intl.formatMessage({ id: "wo_report_summary_tasks" }),
      children: intl.formatMessage(
        { id: "wo_report_summary_tasks_value" },
        { count: taskCount, withPictures: tasksWithPictures }
      ),
    },
    {
      key: "task_pictures",
      label: intl.formatMessage({ id: "wo_report_summary_task_pictures" }),
      children: taskPictureCount,
    },
    ...(showGeneralPictures
      ? [
          {
            key: "general_pictures",
            label: intl.formatMessage({ id: "wo_report_step_general_pictures" }),
            children: generalPictureCount,
          },
        ]
      : []),
    {
      key: "supplies",
      label: intl.formatMessage({ id: "wo_report_step_supplies" }),
      children: usedSupplyCount,
    },
  ];

  return (
    <Flex vertical gap="middle">
      <Descriptions bordered size="small" column={1} items={items} />
      <Alert
        type="info"
        showIcon
        title={intl.formatMessage({ id: "wo_report_summary_saved_note" })}
      />
    </Flex>
  );
}
